import AppRoutes from './routes';
import { Analytics } from "@vercel/analytics/react"
import './Global.css';  

function App() {
  return (
    <div className="app-container">
      <AppRoutes />
      <Analytics />
    </div>
  );
}

export default App;
